import React, { createContext, useContext, useState, useEffect } from "react";
import config from "../config/config";

const UserContext = createContext();
const API_URL = config.API_URL;

export const UserProvider = ({ children }) => {
  const [account, setAccount] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [authority, setAuthority] = useState(null);
  const [loading, setLoading] = useState(true);
  const [company, setCompany] = useState("");
  const [incubator, setIncubator] = useState("");

  // 초기 로그인 또는 권한 확인
  const fetchUserType = async () => {
    try {
      const response = await fetch(`${API_URL}/api/auth/check-session`, { 
        method: "GET",
        credentials: "include" 
      });
      if (response.ok) {
        const data = await response.json();
        // console.log(data);
        setAccount(data.user);
        setIsLoggedIn(data.isLoggedIn);
        setAuthority(data.authority); // ✅ 권한 저장
        if(data.company){
          setCompany(data.company);
        }
        setIncubator(data.incubator);
        console.log('세션 체크 확인 성공', data.isLoggedIn, data.authority);
      } else {
        console.log('세션 체크 실패', response.json());
        handleSessionExpired();
      }
    } catch (error) {
      console.error("Error checking session:", error);
    }finally{
      setLoading(false);
    }
  };

  const handleSessionExpired = () =>{
    setIsLoggedIn(false);
    setAuthority(null);
    window.location.reload();
  }

  // 1. 로그인 상태 확인 및 초기 권한 확인
  useEffect(() => {
    console.log('초기 상태 확인, userContext');
    fetchUserType();

  }, []);

  // 2. 주기적 권한 확인
  useEffect(() => {
    console.log('userContext, interval check');
    if (isLoggedIn) {
      const interval = setInterval(fetchUserType, 5 * 60 * 1000); // 5분마다 권한 확인
      return () => clearInterval(interval); // 컴포넌트 언마운트 시 정리
    }
  }, [isLoggedIn]);

  if (loading) {
    return <div>Loading... 🔄</div>; // ✅ 로딩 표시
  }

  return (
    <UserContext.Provider value={{ isLoggedIn, setIsLoggedIn, authority, setAuthority, company, incubator, account }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);